import React from "react";

function OrderReports({ colorCode }) {
  return (
    <svg className="MuiSvgIcon-root" viewBox="0 0 24 24" fill="none">
      <rect
        x="3"
        y="4"
        width="18"
        height="16"
        rx="2"
        stroke={colorCode}
        strokeWidth="2"
      />
      <path
        d="M8 11L8 17"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13V17"
        stroke="#51CBFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 9V17"
        stroke={colorCode}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default OrderReports;
